<template>
    <div class="expand-collapse">
        <v-btn variant="text" class="expand-collapse__btn" size="small" @click="expandAll">
            <icon class="expand-collapse__btn--icon" icon-name="custom:expand-all" />
            {{ toSentenceCase($t('subCampaignAllocation.expandCollapse.expandAll')) }}
        </v-btn>
        <v-btn variant="text" class="expand-collapse__btn" size="small" @click="collapseAll">
            <icon class="expand-collapse__btn--icon" icon-name="custom:collapse-all" />
            {{ toSentenceCase($t('subCampaignAllocation.expandCollapse.collapseAll')) }}
        </v-btn>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    methods: {
        expandAll() {
            if (!this.params.expandAll) return;
            this.params.expandAll();
        },
        collapseAll() {
            if (!this.params.collapseAll) return;
            this.params.collapseAll();
        },
    },
});
</script>

<style lang="scss">
@import '@style/base/_variables.scss';

.expand-collapse {
    display: flex;

    .v-icon.v-icon {
        font-size: 1.4rem !important;
    }

    .expand-collapse__btn {
        color: $promo-primary-colour !important;
        text-decoration: underline;

        .v-btn__content {
            font-size: 1.4rem;

            .v-icon {
                padding-top: 0.2rem;
                padding-right: 0.4rem;
            }
        }
    }
}
</style>
